import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import TaskProcessingProcessService from '../../components/services/TaskProcessingProcessService';

const useTaskProcessingProcessService = () => {
  return useMemo(() => new TaskProcessingProcessService(new ApiCalls()), []);
};

export default useTaskProcessingProcessService;
